import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPriorityHigh = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.7803 15.0303C19.0732 14.7374 19.0732 14.2626 18.7803 13.9697L12.7803 7.96967C12.4874 7.67678 12.0126 7.67678 11.7197 7.96967L5.71967 13.9697C5.42678 14.2626 5.42678 14.7374 5.71967 15.0303C6.01256 15.3232 6.48744 15.3232 6.78033 15.0303L12.25 9.56066L17.7197 15.0303C18.0126 15.3232 18.4874 15.3232 18.7803 15.0303Z",
		fill: "currentColor"
	})
});
export { SvgIconPriorityHigh as ReactComponent };
